import React, { useState, useEffect } from "react";
import TabTitle from "./TabsTitle";
import ListViewCard from "../../HotelItem/ListViewCard";
import ListViewCardSmall from "../../HotelItem/ListViewCardSmall";
import "./style.scss";
import { GetFavoritesService } from "../../../services/GetFavoritesService";
import { useDispatch, useSelector } from "react-redux";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import { setActivityIndicator } from "../../../redux/slices/appconfigSlice";
import { useNavigate } from "react-router-dom";
import "react-swipeable-list/dist/styles.css";
import useTranslationCustom from "../../../i18n/customHook/useTranslation";

const FavoriteTabContent = () => {
  const { T } = useTranslationCustom();
  const dispatch = useDispatch();
  const loginconfig = useSelector(getLoginConfig);
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    if (loginconfig?.loginUser?.guid && loginconfig?.isLogin) {
      GetFavoriteHotels();
    }
  }, [loginconfig?.isLogin, loginconfig.currency]);

  const GetFavoriteHotels = () => {
    dispatch(setActivityIndicator(true));
    GetFavoritesService({ GUID: loginconfig?.loginUser?.guid })
      .then((response) => {
        dispatch(setActivityIndicator(false));
        setPackages(response.favoritePackages);
      })
      .catch((error) => {
        console.log({ error });
        dispatch(setActivityIndicator(false));
      });
  };

  const routeToSearchScreen = (event) => {
    event.preventDefault();
    navigate('/', { replace: true });
  };

  const deleteFavouritePkg = (index) => {
    if (loginconfig?.loginUser?.guid && loginconfig?.isLogin) {
      setPackages(packages.filter((f, i) => i !== index));
      dispatch(setActivityIndicator(false));
    }
  };

  return (
    <>
      <div className="d-flex gap-3 align-items-center left-action-back-btn">
        <a className="black-back-btn" onClick={() => navigate(-1)}>{T("Buttons:Back")}</a>
        <TabTitle title={T("Home:Home_My_Favourites")}></TabTitle>
      </div>
      <div className="tabs-inner-content favourites-tab">
        {!packages.length ? (
          <div className="has-no-fav">
            <h6 className="green-text fs-16 font-noto">
              {T("Profile:Nothing_Added")}
            </h6>
            <p className="white-text fs-16 font-noto">
              {T("Profile:Nothing_Added_Description")}
            </p>
            <a className="destinaotion-action" onClick={routeToSearchScreen}>
              {T("Profile:Discover_Destinations")}
            </a>
          </div>
        ) : (
          <>
            <div className="for-dekstop">
              {packages?.map((_package, index) => {
                return (
                  <ListViewCard
                    key={index}
                    offer={_package}
                    index={index}
                    handler={deleteFavouritePkg}
                  />
                );
              })}
            </div>
            <div className="for-small">
              {packages?.map((_package, index) => {
                return (
                  <ListViewCardSmall
                    key={index}
                    offer={_package}
                    index={index}
                    handler={deleteFavouritePkg}
                  />
                );
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FavoriteTabContent;
